/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */

import axios from "axios"
import amplitude from "amplitude-js"

var analyticPromise = axios
  .get("/services/analytic/apikey")
  .then(response =>
    amplitude.getInstance().init(response.data, null, {
      includeReferrer: true,
      includeUtm: true,
      includeGclid: true
    })
  )
  .catch(() => console.log("Analytic SDK was not initialized"))

export default {
  deviceId: function() {
    return amplitude.getInstance().options.deviceId
  },

  logAnalyticLegacy: function(analyticName) {
    axios.put(`/services/analytic?event=${analyticName}`)
  },

  logAnalytic: function(analyticName, params) {
    analyticPromise.then(() =>
      amplitude.getInstance().logEvent(analyticName, params || {})
    )
  },

  setUserProperties: function(userId, properties) {
    analyticPromise.then(() => {
      amplitude.getInstance().setUserId(userId)
      amplitude.getInstance().setUserProperties(properties) // triggers a call
    })
  }
}



// WEBPACK FOOTER //
// ./src/service/analytics.js